import AssessmentPromptField, {
  ASSESSMENT_PROMPT_DEFAULT_INFO,
  ASSESSMENT_PROMPT_MAX_LENGTH,
} from "./AssessmentPromptField";
import { useDefaultAssessmentPrompt } from "../../../hooks/useDefaultAssessmentPrompt";

type AssessmentPromptFieldWithDefaultProps = Readonly<{
  conceptCode: string;
  /** Reference Object type → API `target_type`. */
  objectType?: string;
  /**
   * Assessment Template UI label or API code → default-prompt `assessment_type`
   * (`tagging` | `implementation`). Implementation returns extra Impact Level policy.
   */
  assessmentTemplate?: string;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  helperText?: string;
  maxLength?: number;
  label?: string;
  required?: boolean;
  defaultPromptInfoText?: string;
}>;

export default function AssessmentPromptFieldWithDefault({
  conceptCode,
  objectType,
  assessmentTemplate,
  value,
  onChange,
  error = false,
  helperText,
  maxLength = ASSESSMENT_PROMPT_MAX_LENGTH,
  label = "Prompt",
  required = false,
  defaultPromptInfoText = ASSESSMENT_PROMPT_DEFAULT_INFO,
}: AssessmentPromptFieldWithDefaultProps) {
  // Do not pass Reference Dimension value codes as `sub_type` — default-prompt
  // subtypes from Object type only (e.g. insight → regulation).
  const { defaultPrompt, loading } = useDefaultAssessmentPrompt(conceptCode, {
    targetType: objectType,
    assessmentType: assessmentTemplate,
  });

  // Default-prompt fetch failures must not surface as Prompt field errors —
  // the field only shows validation helperText from the parent form.
  return (
    <AssessmentPromptField
      value={value}
      suggestedPrompt={defaultPrompt}
      suggestedPromptLoading={loading}
      onChange={onChange}
      error={error}
      helperText={helperText}
      maxLength={maxLength}
      label={label}
      required={required}
      showDefaultPromptInfo
      defaultPromptInfoText={defaultPromptInfoText}
    />
  );
}
